<script setup lang="ts">
import { ref } from 'vue'
import { CollapsibleContent, CollapsibleRoot, CollapsibleTrigger } from 'radix-vue'
import Arrow from '@/assets/icons/dropdown-arrow.svg'
import SmallPlayingCard from '@/views/SmallPlayingCard.vue'
import type { SuggestedAction } from '@acepoker/contract'
import HistorySuggestedActions from './HistorySuggestedActions.vue'
import type { Action } from '@acepoker/contract/action'
import PlayerActionItem from '@/components/topbar/PlayerActionItem.vue'
import CommunityCardItem from '@/components/topbar/CommunityCardItem.vue'

const isOpen = ref(false)
const props = defineProps<{
  id: string | number
  icon: Object
  playerCards: { rank: string; suit: string }[]
  communityCards: { rank: string; suit: string }[]
  strategy: number
  ev: number
  suggestedActions: SuggestedAction[]
  actionNameRaw: string
  handHistory: Action[]
}>()
</script>

<template>
  <CollapsibleRoot
    class="color-textInactive mt-[4px]"
    :forceMount="false"
    :open="isOpen"
    @update:open="() => (isOpen = !isOpen)"
  >
    <CollapsibleTrigger
      class="flex flex-row items-center w-full h-[40px] p-[4px] bg-dark-grey text-text-inactive rounded"
    >
      <component :is="props.icon" width="24px" height="24px" alt="label" class="mr-[12px]" />
      <div class="h-full flex flex-row items-center gap-[2px]">
        <small-playing-card
          v-for="(card, i) in props.playerCards"
          :key="i"
          :value="card.rank + card.suit"
        />
      </div>
      <div class="w-[10px]" />
      <div
        class="h-full flex flex-row items-center gap-[2px]"
        v-if="props.communityCards.length !== 0"
      >
        <small-playing-card
          v-for="(card, i) in props.communityCards"
          :key="i"
          :value="card.rank + card.suit"
        />
      </div>
      <div class="grow" />
      <Arrow :class="`flex justify-self-end mr-[8px] ${isOpen && 'rotate-180'}`" />
    </CollapsibleTrigger>
    <CollapsibleContent v-if="isOpen">
      <div class="flex flex-wrap gap-2">
        <div v-for="(item, index) in props.handHistory" :key="index">
          <button>
            <player-action-item
              v-if="item.type === 'action'"
              :item="item"
              :is-last="index === props.handHistory.length - 1"
            />
            <community-card-item v-else :item="item" />
          </button>
        </div>
      </div>
      <history-suggested-actions
        class="mt-3"
        :actions="props.suggestedActions"
        :lastActionNameRaw="props.actionNameRaw"
      />
    </CollapsibleContent>
  </CollapsibleRoot>
</template>
